module Visonum.BulkPingApp.App.Error
  ( view
  ) where

import Visonum.BulkPingApp.Prelude

import Data.String as Str
import Halogen.HTML.Elements as H
import Halogen.HTML.Events as HE
import Halogen.HTML.Properties as HP
import Visonum.BulkPingApp.Imgs (imgCross)

type Props a =
  { title :: String
  , message :: String
  , onClose :: a
  }

view :: forall w a. Props a -> AppHTML w a
view props =
  let
    elRoot = styleNode H.div
      "Error"
      [ inline
          { display: "grid"
          , width: "100%"
          , height: "100%"
          , gridTemplateColumns: "1fr 40px"
          , gridTemplateRows: "1fr 1fr"
          , gap: "10px"
          , gridTemplateAreas: Str.joinWith " "
              [ "\"Title   Close\""
              , "\"Message Close\""
              ]
          , fontFamily: "Arial"
          }
      ]

    elCloseIcon = styleLeaf H.img
      "ErrorCloseIcon"
      [ inline
          { gridArea: "Close"
          , cursor: "pointer"
          , width: "30px"
          , height: "30px"
          }
      ]

    elTitle = styleNode H.div
      "ErrorTitle"
      [ inline
          { gridArea: "Title"
          , fontSize: "1.5em"
          , fontWeight: "bold"
          }
      ]

    elMessage = styleNode H.div
      "ErrorMessage"
      [ inline
          { gridArea: "Message"
          , fontSize: "10px"
          , color: "black"
          }
      ]

  in
    elRoot
      []
      [ elTitle [] [ text props.title ]
      , elMessage [] [ text props.message ]
      , elCloseIcon
          [ HP.src imgCross
          , HE.onClick \_ -> props.onClose
          ]
      ]
